module.exports = __webpack_public_path__ + "8bc1f8138ebb78b6834088c4888b84f4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/beak/long-s.png
// module id = 1817
// module chunks = 0